import {type TypographyProps, Typography} from '@yandex-delivery/blocks'
import {SafeHTML} from '@yandex-delivery/xss-defender'
import type {CSSProperties} from 'react'

import type {TextWidgetProps as Props} from '../types'

export function TextWidget({config}: Props): React.ReactElement {
  const {
    color: colorProp, //
    font_size: fontSize,
    font_weight: thickness,
    text,
  } = config
  const color = colorMap[colorProp]
  const variant = variantMap[fontSize]
  const style: CSSProperties | undefined = fontSize ? {fontSize} : undefined

  return (
    <Typography color={color} style={variant ? undefined : style} thickness={thickness} variant={variant}>
      <SafeHTML html={text} />
    </Typography>
  )
}

// TODO: вынести в fetch
const variantMap: Record<number, TypographyProps['variant']> = {
  16: 'body2',
  13: 'caption1',
  20: 'title4',
}
const colorMap: Record<string, TypographyProps['color']> = {
  textMain: 'main',
  textMinor: 'minor',
  error: 'error',
  // TODO: понять, на какой цвет мапить textOnControl
  // textOnControl: ???
}
